module.exports = __webpack_public_path__ + "img/aeroland-sass-image-04.bacc711f.jpg";